import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Block } from 'src/config/api/models/Block';
import { addFakeCluster } from './helpers';

export type PresentationMode = {
  showPresentationMode: boolean;
  presentingIndex: number;
  length: number;
  animation: null | any;
  blocksToPresent: Block[] | null;
  pageBlockIdToPresent: string | null;
  blocksToObserve: string[] | [];
};

type SetShowPresentationMode = {
  showPresentationMode: PresentationMode['showPresentationMode'];
  blocksToPresent?: PresentationMode['blocksToPresent'];
};

const initialState: PresentationMode = {
  showPresentationMode: false,
  presentingIndex: 0,
  length: 0,
  animation: null,
  blocksToPresent: null,
  pageBlockIdToPresent: null,
  blocksToObserve: [],
};

export const presentationMode = createSlice({
  name: 'presentationMode',
  initialState,
  reducers: {
    setShowPresentationMode: (state, action: PayloadAction<SetShowPresentationMode>) => {
      let newBlocks = null;
      const pageBlockIdToPresent = state.pageBlockIdToPresent;

      if (action.payload.blocksToPresent) {
        const blocks = action.payload.blocksToPresent;
        const result: Block[] = [];
        let fakeChildBlocks: Block[] = [];
        blocks?.forEach((block, index) => {
          if (block.type === 'cluster' && block?.sections) {
            if (fakeChildBlocks.length) {
              result.push(addFakeCluster(fakeChildBlocks));
              fakeChildBlocks = [];
            }
            block?.sections.map((sectionItem, sectionIndex) => {
              const newFakeCluster = {
                ...block,
                sections: [sectionItem],
                hideClusterTitle: sectionIndex !== 0,
              };
              return result.push(newFakeCluster);
            });
          } else {
            fakeChildBlocks.push(block);
            if (index === blocks.length - 1) {
              result.push(addFakeCluster(fakeChildBlocks));
              fakeChildBlocks = [];
            }
          }
        });
        newBlocks = result;
      }

      let outerIndex = 0;
      let blocksToObserve: string[] = [];
      if (pageBlockIdToPresent && newBlocks) {
        newBlocks.map((cluster, index) =>
          cluster.sections?.map((sections) =>
            sections.childBlocks?.map((block) => {
              blocksToObserve.push(`block_wrapper-${block.id}`);
              if (block.id === pageBlockIdToPresent) {
                outerIndex = index;
              }
              return block;
            })
          )
        );
      }

      return {
        ...state,
        showPresentationMode: action.payload.showPresentationMode,
        blocksToPresent: newBlocks,
        length: newBlocks?.length || 0,
        presentingIndex: outerIndex ? outerIndex : 0,
        blocksToObserve,
      };
    },
    setPresentingIndex: (state, action: PayloadAction<PresentationMode['presentingIndex']>) => {
      if (action.payload < 0 || action.payload >= state.length) {
        return { ...state, animation: 'bounce' };
      }
      return { ...state, presentingIndex: action.payload };
    },
    setAnimation: (state, action: PayloadAction<PresentationMode['animation']>) => {
      return { ...state, animation: action.payload };
    },
    setHandleUpArrow: (state) => {
      if (state.presentingIndex > 0) {
        return {
          ...state,
          presentingIndex: state.presentingIndex - 1,
          animation: 'appear-from-top',
        };
      } else {
        return { ...state, animation: 'bounce' };
      }
    },
    setHandleDownArrow: (state) => {
      if (state.presentingIndex < state.length - 1) {
        return {
          ...state,
          presentingIndex: state.presentingIndex + 1,
          animation: 'appear-from-bottom',
        };
      } else {
        return { ...state, animation: 'bounce' };
      }
    },
    setPageBlockIdToPresent: (
      state,
      action: PayloadAction<PresentationMode['pageBlockIdToPresent']>
    ) => {
      return { ...state, pageBlockIdToPresent: action.payload };
    },
    resetAnimation: (state) => {
      return { ...state, animation: 'slide-active' };
    },
    resetPresentationMode: () => {
      return initialState;
    },
  },
});

export const {
  setShowPresentationMode,
  setPresentingIndex,
  setAnimation,
  setHandleUpArrow,
  setHandleDownArrow,
  resetAnimation,
  resetPresentationMode,
  setPageBlockIdToPresent,
} = presentationMode.actions;

export const { reducer: presentationModeReducer } = presentationMode;
